import { Spin } from "antd";

const AppLoadingMask = () => (
  <div className="app-loading-mask">
    <Spin />
  </div>
);
export default AppLoadingMask;
